export enum AccountTypeEnum {
  BORROWER = 'Sponsor',
  LENDER = 'Lender',
  BROKER = 'Broker',
}

export const BROKER_DISPLAY_ALIAS = 'Debt Advisor';
